import { idleState, combineReducers, failedState, loadingState } from '@grandvisionhq/state';
import { unlinkOrderFailed, unlinkOrderSuccess, unlinkOrder } from './Unlink/actions.js';
import { initialState as initialState$2, cccReducer } from './CCC/reducer.js';
import { initialState as initialState$3, prescriptionsReducer } from './Prescriptions/state/reducer.js';
import { initialState as initialState$1, profileReducer } from './Profile/reducer.js';

const initialState = {
    profile: initialState$1,
    ccc: initialState$2,
    prescriptions: initialState$3,
    unlinkOrderCall: idleState()
};
const unlinkOrderReducer = (state = initialState.unlinkOrderCall, action)=>{
    switch(action.type){
        case unlinkOrder.type:
            return loadingState();
        case unlinkOrderSuccess.type:
            return idleState();
        case unlinkOrderFailed.type:
            return failedState(action.error);
        default:
            return state;
    }
};
var reducer = combineReducers({
    profile: profileReducer,
    ccc: cccReducer,
    prescriptions: prescriptionsReducer,
    unlinkOrderCall: unlinkOrderReducer
});

export { reducer as default, initialState };
//# sourceMappingURL=reducer.js.map
